// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IeB7","fullView":"styles_fullView__1Lq0l"};